



























import Vue from 'vue';
import ButtonActivate from '@/components/campaign/ButtonActivate.vue';
import ButtonPause from '@/components/campaign/ButtonPause.vue';
import ButtonEdit from '@/components/campaign/ButtonEdit.vue';
import ButtonDuplicate from '@/components/campaign/ButtonDuplicate.vue';
import ButtonCancel from '@/components/campaign/ButtonCancel.vue';
export default Vue.extend({
  components: { ButtonActivate, ButtonEdit, ButtonPause, ButtonDuplicate, ButtonCancel},
  props: {
    onBack: Function,
    route: Object,
  },
  computed: {
    title(): string {
      const title = this.$store.state.campaign.campaign && this.$store.state.campaign.campaign.title;
      if (this.route.name === 'campaignList') {
        return 'Campanhas';
      } else if (this.route.name === 'campaignView') {
        return title || 'Sem título';
      } else if (this.route.name === 'campaignCreate') {
        return 'Criar Campanha';
      } else if (this.route.name === 'campaignEdit') {
        return `Editar - ${title || 'Sem título'}`;
      }
      return '';
    },
  },
});
